import { Directive, ElementRef, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '[appRevealOnScroll]',
  standalone: true
})
export class RevealOnScrollDirective implements OnInit, OnDestroy {
  @Input('appRevealOnScroll') delay = '0ms';

  @HostBinding('class.is-visible') isVisible = false;
  @HostBinding('style.--reveal-delay') get revealDelay(): string {
    return this.delay;
  }

  private observer?: IntersectionObserver;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    // this.observer = new IntersectionObserver(
    //   (entries) => {
    //     entries.forEach((entry) => {
    //       if (entry.isIntersecting) {
    //         this.isVisible = true;
    //         this.observer?.disconnect();
    //       }
    //     });
    //   },
    //   { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    // );

    // this.observer.observe(this.el.nativeElement);

    // Fallback to immediately show if already in view on load
    // requestAnimationFrame(() => this.markVisibleIfInView());
  }

  ngOnDestroy(): void {
    // this.observer?.disconnect();
  }

  private markVisibleIfInView(): void {
    // const rect = this.el.nativeElement.getBoundingClientRect();
    // const inView = rect.top < window.innerHeight * 0.9 && rect.bottom > 0;
    // if (inView) {
    //   this.isVisible = true;
    //   this.observer?.disconnect();
    // }
  }
}
